import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });

export const IMG = {
  studio: "https://static.prod-images.emergentagent.com/jobs/2dc59029-ddf8-4640-baf9-e24133421540/images/1dc522113b391def7f5770b210dc185d6ff6abd44da561b92276f47b1303140c.jpeg",
  kitchen: "https://static.prod-images.emergentagent.com/jobs/2dc59029-ddf8-4640-baf9-e24133421540/images/3fab50ab1713898ef9a4e599c39708d956b4ee578a6be4cf5275a3b62310879b.jpeg",
  pour: "https://static.prod-images.emergentagent.com/jobs/2dc59029-ddf8-4640-baf9-e24133421540/images/85175e810336e1d476dce454ac177423426704247f28742908c000a709fc5f8c.jpeg",
  flatlay: "https://static.prod-images.emergentagent.com/jobs/2dc59029-ddf8-4640-baf9-e24133421540/images/d37ad36e0dafa7fc220a885eb3d2dd37b0f38c757cda2bad0866715b70ea70ed.jpeg",
  friends: "https://static.prod-images.emergentagent.com/jobs/2dc59029-ddf8-4640-baf9-e24133421540/images/9572c79ee03fe8dd42c360f3587651d15e45bb013a8e8f1be198abb1c1609ecf.jpeg",
};

IMG.kathryn = "https://static.prod-images.emergentagent.com/jobs/2dc59029-ddf8-4640-baf9-e24133421540/images/6893e5decf64af387e05692cd8fa58e3928130bd2cb60666a1a5654ee54a3f1f.jpeg";

export const PRICE = 250;
export const SHIPPING = 15;
export const TAX_PERCENT = 8.85;

export const usd = (n) => `$${Number(n ?? 0).toFixed(2)}`;

export const quoteFor = (qty) => {
  const subtotal = PRICE * qty;
  const tax = Math.round(subtotal * TAX_PERCENT) / 100;
  return { subtotal, shipping: SHIPPING, tax, total: subtotal + SHIPPING + tax };
};

export const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return e?.message || "Something went wrong";
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
